import React from "react";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";

const GRADE_PRESETS = [
  { label: "K-12 (Kindergarten through Grade 12)", value: "k-12" },
  { label: "1-10 (Grade 1 through Grade 10)", value: "1-10" },
  { label: "1-8 (Grade 1 through Grade 8)", value: "1-8" },
  { label: "Other (Define Later)", value: "other" },
];

export default function AcademicConfigStep({ formData, updateField, onNext, onBack }) {
  const handleStartDateChange = (e) => {
    const startDate = e.value;
    updateField("sessionStartDate", startDate);

    if (startDate instanceof Date) {
      const endDate = new Date(startDate);
      endDate.setFullYear(endDate.getFullYear() + 1);
      updateField("sessionEndDate", endDate);

      const startYear = startDate.getFullYear();
      const endYear = endDate.getFullYear();
      updateField("sessionName", `${startYear}-${endYear}`);
    }
  };

  return (
    <div>
      <div className="step-title">Academic Configuration</div>

      <div className="p-field">
        <label htmlFor="sessionName">Academic Session Name</label>
        <InputText
          id="sessionName"
          value={formData.sessionName}
          onChange={(e) => updateField("sessionName", e.target.value)}
          placeholder={`e.g. ${new Date().getFullYear()}-${new Date().getFullYear() + 1}`}
        />
      </div>

      <div className="p-field">
        <label htmlFor="sessionStartDate">Session Start Date</label>
        <Calendar
          id="sessionStartDate"
          value={formData.sessionStartDate}
          onChange={handleStartDateChange}
          dateFormat="yy-mm-dd"
          showIcon
        />
      </div>

      <div className="p-field">
        <label htmlFor="sessionEndDate">Session End Date</label>
        <Calendar
          id="sessionEndDate"
          value={formData.sessionEndDate}
          onChange={(e) => updateField("sessionEndDate", e.value)}
          dateFormat="yy-mm-dd"
          showIcon
        />
      </div>

      <div className="p-field">
        <label htmlFor="gradePreset">Grade Structure</label>
        <Dropdown
          id="gradePreset"
          value={formData.gradePreset}
          options={GRADE_PRESETS}
          onChange={(e) => updateField("gradePreset", e.value)}
          placeholder="Select grade structure"
        />
      </div>

      <div className="step-actions">
        <Button
          label="Back"
          icon="pi pi-arrow-left"
          className="p-button-secondary"
          onClick={onBack}
        />
        <Button
          label="Next"
          icon="pi pi-arrow-right"
          iconPos="right"
          onClick={onNext}
        />
      </div>
    </div>
  );
}
